import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { getAccessToken } from '../utils/auth';

function Logout() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const performLogout = async () => {
      // Get access token before clearing
      const token = await getAccessToken();
      
      // Clear cookie
      document.cookie = 'access-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + process.env.REACT_APP_UI_DOMAIN + ";";
      // Clear local storage
      localStorage.removeItem('chatThread');
      localStorage.removeItem('messagesFetched');

      // Initiate the logout workflow with the Orchestrator Authorization endpoint
      try {
        const client = searchParams.get('client');
        const clientId = searchParams.get('client_id');
        const state = searchParams.get('state');
        
        let url = `${process.env.REACT_APP_ORCHESTRATOR_AUTHORIZATION_SERVER}/auth/logout`;
        url += client ? `?client=${client}` : `?client=react`;
        if (clientId) url += `&client_id=${clientId}`;
        if (state) url += `&state=${state}`;
        
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`
          },
        });

        console.log("Response type is --> "+response.type)

        if (response.ok) {
          const data = await response.json()
          const redirectUrl = data["redirect_url"]
          console.log("Redirecting user to: "+redirectUrl.replaceAll('"', ''))
          // Redirect only if the client requesting the logout is the CLI
          if (client === 'cli') window.location.href = redirectUrl.replaceAll('"', '');
          // If the client requesting the logout is not the CLI, just go to this logout page acknowledging successfull logout (see below)
        } else {
          console.log("Logout API: "+process.env.REACT_APP_ORCHESTRATOR_AUTHORIZATION_SERVER+"/auth/logout");
          console.log("Unable to redirect logout request to authorization endpoint - Returned status: "+response.status)
          // navigate('/login');
        }
      } catch (error) {
        console.error('Error during logout:', error);
        // navigate('/login');
      }
    };
    
    performLogout();
  }, [navigate, searchParams]);

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <div className="logout-container">
      <img src="./media/applucent-logo.jpeg" alt="Applucent Logo" className="logout-logo" />
      <h2>Successfully Logged Out</h2>
      <p>You have been successfully logged out of your account.</p>
      <button onClick={handleLoginRedirect} className="login-button">
        Login
      </button>
    </div>
  );
}

export default Logout;